(() => {
  if(customElements.get('oc-related-products'))return;
  customElements.define('oc-related-products',class extends HTMLElement {
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();this.wire();
      if(this.dataset.url){this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'300px'});this.observer.observe(this);}
    }
    disconnectedCallback(){this.abort?.abort();this.events?.abort();this.resize?.disconnect();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
    async load(){
      if(this.loading)return;this.loading=true;
      try{
        const response=await fetch(this.dataset.url,{signal:this.abort.signal,headers:{Accept:'text/html'}});if(!response.ok)throw new Error('Recommendations unavailable');
        const html=await response.text();if(!this.isConnected)return;
        const doc=new DOMParser().parseFromString(html,'text/html');const source=[...doc.querySelectorAll('oc-related-products')].find(el=>el.dataset.section===this.dataset.section);
        const content=source?.querySelector('[data-content]');if(!content)throw new Error('Missing recommendations section');
        // Keep the selected fallback when the response has no usable products.
        if(content.querySelector('[data-card]')){this.querySelector('[data-content]').replaceWith(content);this.querySelector('[data-editor-note]')?.remove();this.wire();}
        delete this.dataset.url;
      }catch(error){if(error.name!=='AbortError')this.dataset.loadFailed='true';}
      finally{this.loading=false;}
    }
    wire(){
      this.events?.abort();this.events=new AbortController();this.resize?.disconnect();
      const opts={signal:this.events.signal};this.track=this.querySelector('.oc-rp__track');if(!this.track)return;
      this.buttons=[...this.querySelectorAll('[data-step]')];
      this.classList.add('is-interactive');
      for(const link of this.querySelectorAll('.oc-rp__image-link')){
        let start=null, blockClickUntil=0;
        const card=link.closest('[data-card]');
        let dragWidth=0,dragRtl=false,dragEnabled=false;
        const beginDrag=()=>{
          dragEnabled=!!link.querySelector('.oc-rp__image--second') && !matchMedia('(prefers-reduced-motion: reduce)').matches;
          if(dragEnabled){dragWidth=link.clientWidth;dragRtl=getComputedStyle(link).direction==='rtl';}
        };
        const previewDrag=dx=>{
          if(!dragEnabled)return;
          const forward=(dx<0)!==dragRtl;
          const canChange=forward?!card.classList.contains('is-second'):card.classList.contains('is-second');
          link.classList.add('is-dragging');
          link.style.setProperty('--rp-drag',`${canChange?Math.max(-dragWidth,Math.min(dragWidth,dx)):0}px`);
        };
        const endDrag=()=>{link.classList.remove('is-dragging');link.style.removeProperty('--rp-drag');};
        // Claim horizontal touch gestures before the native scroller cancels
        // pointer events. Vertical scrolling and multi-touch stay native.
        let touch=null;
        link.addEventListener('touchstart',e=>{
          start=null;
          if(e.touches.length!==1){touch=null;endDrag();return;}
          beginDrag();
          const point=e.touches[0];
          touch={id:point.identifier,x:point.clientX,y:point.clientY,dx:0,axis:null};
        },{...opts,passive:true});
        link.addEventListener('touchmove',e=>{
          if(!touch || e.touches.length!==1){touch=null;endDrag();return;}
          const point=[...e.touches].find(p=>p.identifier===touch.id);if(!point)return;
          const dx=point.clientX-touch.x,dy=point.clientY-touch.y;
          if(!touch.axis && Math.max(Math.abs(dx),Math.abs(dy))>=8)touch.axis=Math.abs(dx)>Math.abs(dy)?'x':'y';
          if(touch.axis!=='x')return;
          if(!e.cancelable){touch=null;endDrag();return;}
          e.preventDefault();touch.dx=dx;blockClickUntil=Date.now()+700;
          previewDrag(dx);
        },{...opts,passive:false});
        link.addEventListener('touchend',e=>{
          if(!touch)return;
          const point=[...e.changedTouches].find(p=>p.identifier===touch.id);if(!point)return;
          const gesture=touch;touch=null;
          endDrag();
          if(gesture.axis==='x'){
            if(e.cancelable)e.preventDefault();
            blockClickUntil=Date.now()+700;
            const dx=point.clientX-gesture.x;
            if(Math.abs(dx)>=35){
              const rtl=getComputedStyle(this.track).direction==='rtl';
              this.swipe(link.closest('[data-card]'),(dx<0)!==rtl?1:-1);
            }
          }
        },{...opts,passive:false});
        link.addEventListener('touchcancel',()=>{touch=null;endDrag();},opts);
        link.addEventListener('dragstart',e=>e.preventDefault(),opts);
        link.addEventListener('pointerdown',e=>{
          if(e.pointerType==='touch' || !e.isPrimary || e.button!==0)return;
          beginDrag();
          start={x:e.clientX,y:e.clientY,id:e.pointerId,horizontal:false};
        },opts);
        link.addEventListener('pointermove',e=>{
          if(!start || start.id!==e.pointerId)return;
          const dx=e.clientX-start.x,dy=e.clientY-start.y;
          if(!start.horizontal && Math.abs(dy)>10 && Math.abs(dy)>Math.abs(dx)){start=null;return;}
          if(Math.abs(dx)>10 && Math.abs(dx)>Math.abs(dy)){
            start.horizontal=true;blockClickUntil=Date.now()+500;
            link.setPointerCapture(e.pointerId);
            previewDrag(dx);
          }
        },opts);
        link.addEventListener('pointerup',e=>{
          if(!start || start.id!==e.pointerId)return;
          const dx=e.clientX-start.x,horizontal=start.horizontal;start=null;
          endDrag();
          if(link.hasPointerCapture(e.pointerId))link.releasePointerCapture(e.pointerId);
          if(horizontal && Math.abs(dx)>=35){
            blockClickUntil=Date.now()+500;
            const rtl=getComputedStyle(this.track).direction==='rtl';
            this.swipe(link.closest('[data-card]'),(dx<0)!==rtl?1:-1);
          }
        },opts);
        link.addEventListener('pointercancel',()=>{start=null;endDrag();},opts);
        link.addEventListener('click',e=>{if(Date.now()<blockClickUntil){e.preventDefault();e.stopPropagation();}},opts);
      }
      this.querySelectorAll('.oc-rp__dots').forEach(el=>el.hidden=false);
      this.querySelector('.oc-rp__controls')?.removeAttribute('hidden');
      for(const button of this.buttons)button.addEventListener('click',()=>{this.track.scrollBy({left:Number(button.dataset.step)*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},opts);
      for(const button of this.querySelectorAll('[data-image]'))button.addEventListener('click',()=>{const card=button.closest('[data-card]');card.classList.toggle('is-second',button.dataset.image==='2');for(const dot of card.querySelectorAll('[data-image]'))dot.setAttribute('aria-pressed',String(dot===button));},opts);
      this.track.addEventListener('scroll',()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.sync();});},{...opts,passive:true});
      this.resize=new ResizeObserver(()=>this.sync());this.resize.observe(this.track);this.sync();
    }
    showImage(card,second){
      card.classList.toggle('is-second',second);
      for(const dot of card.querySelectorAll('[data-image]'))dot.setAttribute('aria-pressed',String((dot.dataset.image==='2')===second));
    }
    swipe(card,direction){
      const hasSecond=!!card.querySelector('.oc-rp__image--second');
      if(direction>0 && hasSecond && !card.classList.contains('is-second')){this.showImage(card,true);return;}
      if(direction<0 && card.classList.contains('is-second')){this.showImage(card,false);return;}
      if(this.dataset.layout!=='slider')return;
      const next=direction>0?card.nextElementSibling:card.previousElementSibling;
      if(!next)return;
      this.showImage(next,direction<0 && !!next.querySelector('.oc-rp__image--second'));
      const trackStyle=getComputedStyle(this.track);
      const rtl=trackStyle.direction==='rtl';
      const edge=rtl?'right':'left';
      const inset=parseFloat(trackStyle.scrollPaddingInlineStart)||0;
      this.track.scrollBy({left:next.getBoundingClientRect()[edge]-this.track.getBoundingClientRect()[edge]+(rtl?inset:-inset),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    sync(){if(!this.track)return;const max=this.track.scrollWidth-this.track.clientWidth;const left=Math.abs(this.track.scrollLeft);for(const button of this.buttons)button.disabled=Number(button.dataset.step)<0?left<2:left>=max-2;const controls=this.querySelector('.oc-rp__controls');if(controls)controls.hidden=max<2;}
  });
})();
